
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#5F6368","fill-rule":"nonzero","d":"M16 1c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C1 7.716 7.716 1 16 1zm-.18 26c-1.831 0-3.605.283-5.238.819A12.928 12.928 0 0 0 16 29c1.874 0 3.654-.396 5.264-1.11a16.737 16.737 0 0 0-5.445-.89zM16 3C8.82 3 3 8.82 3 16c0 4.33 2.116 8.165 5.371 10.527C10.625 25.532 13.174 25 15.82 25c2.734 0 5.364.568 7.67 1.627A12.982 12.982 0 0 0 29 16c0-7.18-5.82-13-13-13zm6.707 18.293a1 1 0 1 1-1.414 1.414 1 1 0 0 1 1.414-1.414zm-12 0a1 1 0 1 1-1.414 1.414 1 1 0 0 1 1.414-1.414zm12.396-12.35a1 1 0 0 1 .084 1.32l-.084.094-5.161 5.162a2 2 0 1 1-1.388-1.441l5.135-5.136a1 1 0 0 1 1.414 0zM8 15a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm16 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM10.707 9.293a1 1 0 1 1-1.414 1.414 1 1 0 0 1 1.414-1.414zM16 7a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"}})])
          )
        }
      }
    